import { mergeAttributes, Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import CopilotAttachmentNodeView from './CopilotAttachmentNodeView.vue';

export const CopilotAttachment = Node.create({
  name: 'copilotAttachment',

  group: 'inline',

  inline: true,

  selectable: true,

  atom: true,

  addAttributes() {
    return {
      clientId: {
        default: null,
        parseHTML: element => element.getAttribute('data-client-id'),
        renderHTML: attributes => {
          if (!attributes.clientId) return {};
          return { 'data-client-id': attributes.clientId };
        },
      },
      name: {
        default: '',
        parseHTML: element => element.getAttribute('data-name'),
        renderHTML: attributes => {
          if (!attributes.name) return {};
          return { 'data-name': attributes.name };
        },
      },
      mimeType: {
        default: '',
        parseHTML: element => element.getAttribute('data-mime-type') || '',
        renderHTML: attributes => {
          if (!attributes.mimeType) return {};
          return { 'data-mime-type': attributes.mimeType };
        },
      },
      isImage: {
        default: false,
        parseHTML: element => element.getAttribute('data-is-image') === 'true',
        renderHTML: attributes => {
          if (!attributes.isImage) return {};
          return { 'data-is-image': 'true' };
        },
      },
      fileUrl: {
        default: null,
        parseHTML: element => element.getAttribute('data-file-url'),
        renderHTML: attributes => {
          if (!attributes.fileUrl) return {};
          return { 'data-file-url': attributes.fileUrl };
        },
      },
      preview: {
        default: null,
        parseHTML: element => element.getAttribute('data-preview'),
        renderHTML: attributes => {
          if (!attributes.preview) return {};
          return { 'data-preview': attributes.preview };
        },
      },
      uploading: {
        default: false,
        parseHTML: element => element.getAttribute('data-uploading') === 'true',
        renderHTML: attributes => {
          if (!attributes.uploading) return {};
          return { 'data-uploading': 'true' };
        },
      },
      error: {
        default: null,
        parseHTML: element => element.getAttribute('data-error'),
        renderHTML: attributes => {
          if (!attributes.error) return {};
          return { 'data-error': attributes.error };
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: `span[data-type="${this.name}"]` }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(
        { 'data-type': this.name, class: 'copilot-attachment-chip' },
        HTMLAttributes
      ),
    ];
  },

  renderText() {
    return '';
  },

  addNodeView() {
    return VueNodeViewRenderer(CopilotAttachmentNodeView);
  },
});

export default CopilotAttachment;
